<template>
  <div>
    <component :is="layout" />
  </div>
</template>

<script>

import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/300.css';
import Base from './layouts/Base.vue'

export default {
  name: 'App',
  computed: {
    layout(){
      return 'Base'
    }
  },
  components: {
    Base
  },
};
</script>

<style>

body {
  font-family: "Roboto", sans-serif !important;
  font-weight: 500;
}
tbody {
  font-weight: 400;
}

</style>